<script context="module">
    export const MECHANIC = 'mechanic';
    export const REPAIR_STATION = 'repair_station';
</script>

<script>
    import Switch from 'svelte-switch';
    import { createEventDispatcher } from 'svelte';

    export let type = MECHANIC;

    const dispatch = createEventDispatcher();

    const handleChange = event => {
        const checked = event.detail.checked;
        type = checked ? MECHANIC : REPAIR_STATION;
        dispatch('change', type);
    }

    $: checked = type === MECHANIC;
</script>

<div class="signature-switch">
    <span>Repair station</span>

    <Switch
        {checked}
        height="20"
        width="40"
        onColor="#1ab394"
        activeBoxShadow=""
        on:change={handleChange}
        {...$$restProps}
    >
        <div slot="checkedIcon"></div>
    </Switch>

    <span>Mechanic</span>
</div>

<style>
.signature-switch {
    display: flex;
    align-items: center;
    column-gap: 5px;
}
</style>
